var React = require('react');

function BalancedIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#fff"},[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.35 8.1a9 9 0 0 0-10.336 8.4.522.522 0 0 1-.514.5.483.483 0 0 1-.489-.5C1.273 10.657 6.093 6 12 6l.35 2.1zm2.948.99a9.01 9.01 0 0 1 4.579 6.416c.136.817.795 1.494 1.623 1.494s1.51-.675 1.4-1.496a11.011 11.011 0 0 0-8.216-9.174l.614 2.76z","key":0}),React.createElement("path",{"d":"m12 3-1.427 13.318a1.435 1.435 0 1 0 2.854 0L12 3z","key":1})]));
}

BalancedIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = BalancedIcon;

BalancedIcon.default = BalancedIcon;
